<template>
  <div class="page px-5">
    <page-layout>
      <b-row class="mt-5 justify-content-center">
        <img
          src="/login.png"
          href="#"
          width="200px"
        >
      </b-row>
      <b-row class="mt-4 justify-content-center">
        <h4 class="header">
          Administration
        </h4>
      </b-row>
      <b-row class="justify-content-center">
        <div class="header">
          Version 3.1.1
        </div>
      </b-row>
    </page-layout>
  </div>
</template>
<script>
import { mapGetters, mapActions } from "vuex";
import PageLayout from "./shared/PageLayout.vue";

export default {
  name: "Login",
  components: { PageLayout },

  data() {
    return {};
  },
  mounted() {
    this.clearAuthentication();
  },
  methods: {
    ...mapGetters("oidcStore", ["oidcUser", "oidcIsAuthenticated"]),
    ...mapActions("oidcStore", ["removeOidcUser", "signOutOidcSilent"]),

    clearAuthentication() {
      console.log("IsAuthenticated: " + this.oidcIsAuthenticated());
      console.log("User: " + this.oidcUser());
      this.removeOidcUser();
    },
  },
};
</script>
